import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from "./router.js";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//捕捉路由跳转错误
VueRouter.prototype.push = function (location) {
    return originalPush.call(this,location).catch(err=>console.log("路由跳转错误"));
};
VueRouter.prototype.replace = function (location) {
    return originalReplace.call(this,location).catch(err=>console.log("路由跳转错误"));
};

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes:routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    next();
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js